import { createGlobalStyle } from 'styled-components'
import { colors } from '../../theme'

export const GlobalStyle = createGlobalStyle`
*{
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body, html, input, select, button{
  font-family: 'Poppins', sans-serif;
}
body{
  background: ${colors.grey100};
  /* Sem uma cor base o texto nao estilizado herda o preto default do
     navegador e desaparece sobre o fundo escuro. */
  color: ${colors.grey900};
}
/* Pinta a barra de rolagem e os controles nativos (select, checkbox nativo,
   autofill) no esquema escuro — sem isto o Chrome desenha widget claro. */
:root{
  color-scheme: dark;
}

/* ---------------------------------------------------------------------------
   Base dos campos de formulario.

   19 dos inputs do projeto (17 arquivos) NAO declaram fundo nem cor de texto:
   ficavam no default do agente de usuario, que sob tema escuro nao acompanha a
   paleta e destoa do cartao — o caso mais visivel e a busca das listagens
   (Clientes, Produtos, Vendas, Empresas, Vendedores...). Como nao ha componente
   de Input compartilhado, a base vive aqui.

   ⚠️ O :where() aqui NAO e enfeite — e o que torna isto uma BASE.
   Cada :not([type=...]) carrega a especificidade de um seletor de atributo, de
   modo que input:not([a]):not([b]):not([c]) vale 0-3-1 e passa por cima da
   classe que o styled-components gera (0-1-0): a regra deixaria de ser base e
   viraria imposicao, sobrescrevendo o estilo proprio de TODOS os campos do app
   (foi o que aconteceu — so o login escapava, por usar !important).
   :where() tem especificidade ZERO, entao o seletor volta a valer 0-0-1 e
   qualquer componente com estilo proprio vence, como tem de ser.
   Checkbox, radio e file ficam de fora: tem desenho proprio.
   --------------------------------------------------------------------------- */
input:where(:not([type='checkbox']):not([type='radio']):not([type='file'])),
select,
textarea{
  background-color: ${colors.grey100};
  color: ${colors.grey900};
  border: 1px solid ${colors.grey300};
  border-radius: 8px;
}
input:where(:not([type='checkbox']):not([type='radio']):not([type='file']))::placeholder,
textarea::placeholder{
  color: ${colors.grey500};
}
input:where(:not([type='checkbox']):not([type='radio']):not([type='file'])):focus,
select:focus,
textarea:focus{
  outline: none;
  border-color: ${colors.secondary};
}

/* ---------------------------------------------------------------------------
   Widget de chat do Movidesk (#md-app-widget).

   A aparencia dele e, por decisao, responsabilidade do fornecedor — cor do
   balao, icone e layout se ajustam no PAINEL do Movidesk, nao aqui. As DUAS
   regras abaixo sao a excecao deliberada, no cabecalho do chat: dar mais
   espaco a logo e esconder o titulo (que vem do painel com o nome antigo do
   produto).

   Ambos os elementos ficam no DOM da pagina, dentro de .md-chat-widget-header
   — nao no iframe do chat, que e de outra origem e seria inalcancavel daqui.

   Sobre o !important: verificado em runtime, um a um. O display: none vence
   so pela especificidade (id + classe); ja a altura da logo NAO vence — a
   folha do fornecedor (chat-widget.min.css, bloqueada por CORS para leitura)
   fixa 40px com prioridade. Por isso o !important esta so onde e necessario.
   max-height nao e preciso: testado, height sozinho resolve.

   ⚠️ Override em DOM de terceiro: se o Movidesk trocar essas classes, as
   regras deixam de casar e o cabecalho volta ao padrao dele — degrada, nao
   quebra.
   --------------------------------------------------------------------------- */
#md-app-widget .md-chat-widget-logo{
  height: 80px !important;
}
#md-app-widget .md-chat-widget-title{
  display: none;
}
`
